const MuiChip = {
  size: 'small'
};
export default MuiChip;